import { motion } from 'framer-motion'
import styled from 'styled-components'

const CRTWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 2;
  }

  /* Horizontal RGB scanlines */
  &::before {
    background: repeating-linear-gradient(
      0deg,
      rgb(218, 49, 49) 0px,
      rgb(112, 159, 115) 2px,
      rgb(40, 129, 206) 4px
    );
    mix-blend-mode: overlay;
    opacity: 0.4;
  }

  /* Vertical RGB scanlines */
  &::after {
    background: repeating-linear-gradient(
      90deg,
      rgb(218, 49, 49) 0px,
      rgb(112, 159, 115) 1px,
      rgb(40, 129, 206) 2px
    );
    mix-blend-mode: overlay;
    opacity: 0.3;
  }
`;

const BlackOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 4;
  pointer-events: none;
`;

const ScanlineOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(
    0deg,
    transparent 0px,
    transparent 2px,
    rgba(0, 0, 0, 0.15) 2px,
    rgba(0, 0, 0, 0.15) 4px
  );
  animation: scanlines 0.1s linear infinite;
  z-index: 3;
  pointer-events: none;
  
  @keyframes scanlines {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(4px);
    }
  }
`;

const FlickerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.03);
  animation: flicker 0.15s ease-in-out infinite alternate;
  z-index: 3;
  pointer-events: none;
  
  @keyframes flicker {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0.92;
    }
  }
`;

const ChromaticAberration = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at center,
    transparent 0%,
    rgba(255, 0, 255, 0.03) 50%,
    rgba(0, 255, 255, 0.03) 100%
  );
  z-index: 3;
  pointer-events: none;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const CRTVideoWrapper = ({ children, intensity = 1, enabled = true }) => {
  if (!enabled) {
    return <VideoContainer>{children}</VideoContainer>;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      style={{ position: 'relative', width: '100%', height: '100%' }}
    >
      <CRTWrapper>
        <VideoContainer>{children}</VideoContainer>
        <BlackOverlay />
        <ScanlineOverlay />
        <FlickerOverlay />
        <ChromaticAberration />
      </CRTWrapper>
    </motion.div>
  );
};

// Legacy export for backward compatibility
export const CRTEffect = CRTVideoWrapper; 